var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "captcha-settings" }, [
    _c("div", { staticClass: "settings-group" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.localFieldLabel,
            expression: "localFieldLabel",
          },
        ],
        ref: "fieldLabelInput",
        staticClass: "settings-input",
        attrs: { type: "text", placeholder: "Güvenlik Doğrulaması" },
        domProps: { value: _vm.localFieldLabel },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.localFieldLabel = $event.target.value
            },
            _vm.updateField,
          ],
        },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "settings-group" }, [
      _c("label", { staticClass: "settings-label" }, [_vm._v("Hizalama")]),
      _vm._v(" "),
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.localAlign,
              expression: "localAlign",
            },
          ],
          staticClass: "settings-select",
          on: {
            change: [
              function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.localAlign = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              },
              _vm.updateField,
            ],
          },
        },
        [
          _c("option", { attrs: { value: "left" } }, [_vm._v("Sol")]),
          _vm._v(" "),
          _c("option", { attrs: { value: "center" } }, [_vm._v("Merkez")]),
          _vm._v(" "),
          _c("option", { attrs: { value: "right" } }, [_vm._v("Sağ")]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "settings-group" }, [
      _c("label", { staticClass: "settings-label" }, [
        _vm._v("Placeholder Metni"),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.localPlaceholder,
            expression: "localPlaceholder",
          },
        ],
        ref: "placeholderInput",
        staticClass: "settings-input",
        attrs: { type: "text", placeholder: "Yukarıdaki kodu girin" },
        domProps: { value: _vm.localPlaceholder },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.localPlaceholder = $event.target.value
            },
            _vm.updateField,
          ],
        },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "settings-group" }, [
      _c("label", { staticClass: "settings-label" }, [_vm._v("Görünürlük")]),
      _vm._v(" "),
      _c("div", { staticClass: "settings-checkbox-group" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.localVisibility,
              expression: "localVisibility",
            },
          ],
          staticClass: "settings-checkbox",
          attrs: { type: "checkbox", id: "captcha-visibility" },
          domProps: {
            checked: Array.isArray(_vm.localVisibility)
              ? _vm._i(_vm.localVisibility, null) > -1
              : _vm.localVisibility,
          },
          on: {
            change: [
              function ($event) {
                var $$a = _vm.localVisibility,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.localVisibility = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.localVisibility = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.localVisibility = $$c
                }
              },
              _vm.updateField,
            ],
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "settings-checkbox-label",
            attrs: { for: "captcha-visibility" },
          },
          [_vm._v("\n                Alan görünür\n            ")]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "settings-group" }, [
      _c(
        "label",
        { staticClass: "settings-label", attrs: { for: "slug-input" } },
        [_vm._v("URL Parametresi")]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.localSlug,
            expression: "localSlug",
          },
        ],
        ref: "slugInput",
        staticClass: "settings-input",
        attrs: { type: "text", id: "slug-input", placeholder: "captcha" },
        domProps: { value: _vm.localSlug },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.localSlug = $event.target.value
            },
            function ($event) {
              return _vm.setSlug($event.target.value)
            },
          ],
        },
      }),
      _vm._v(" "),
      _c("small", { staticClass: "settings-help" }, [
        _vm._v("URL parametrelerinde kullanılacak benzersiz tanımlayıcı"),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "settings-label" }, [
      _vm._v("\n            Alan Etiketi\n            "),
      _c("span", { staticClass: "settings-label-required" }, [_vm._v("*")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }